import React, { Fragment } from 'react';
import {translate} from 'react-i18next';
import {compose} from "redux";
import AnnotationForm from './AnnotationForm';
import AnnotationsCard from './AnnotationsCard';
import LayoutAnnotationsCard from './LayoutAnnotationsCard';

const AnnotationsPanel = ({
                           t,
                           annotations,
                           onChange                           
                         }) => {

  const orderAnnotations = [
    {
      label: t('data.nodesConfig.annotations.conceptSchemesOrderAnnotation.label'),
      annotation: annotations.ConceptSchemesOrder,
      annotationName:"ConceptSchemesOrder"
    },
    {
      label: t('data.nodesConfig.annotations.categorySchemesOrderAnnotation.label'),
      annotation: annotations.CategorySchemesOrder,
      annotationName:"CategorySchemesOrder"
    },
    {
      label: t('data.nodesConfig.annotations.layoutCategorySchemesOrderAnnotation.label'),
      annotation: annotations.LayoutCategorySchemesOrder,
      annotationName:"LayoutCategorySchemesOrder"
    },
    {
      label: t('data.nodesConfig.annotations.codelistsOrderAnnotation.label'),
      annotation: annotations.CodelistsOrder,
      annotationName:"CodelistsOrder"
    },
    {
      label: t('data.nodesConfig.annotations.categorisationsOrderAnnotation.label'),
      annotation: annotations.CategorisationsOrder,
      annotationName:"CategorisationsOrder"
    }
  ];


  const firstLayoutAnnotations = [
    {
      label: t('data.nodesConfig.annotations.attributeAsDim.label'),
      annotation: annotations.AttributeAsDim,
      annotationName:"AttributeAsDim"
    },
    {
      label: t('data.nodesConfig.annotations.layoutAggregateCells.label'),
      annotation: annotations.LayoutAggregateCells,
      annotationName:"LayoutAggregateCells"
    },
    {
      label: t('data.nodesConfig.annotations.layoutRow.label'),
      annotation: annotations.LayoutRow,
      annotationName:"LayoutRow"
    },
    {
      label: t('data.nodesConfig.annotations.layoutColumn.label'),
      annotation: annotations.LayoutColumn,
      annotationName:"LayoutColumn"
    },
    {
      label: t('data.nodesConfig.annotations.layoutFilter.label'),
      annotation: annotations.LayoutFilter,
      annotationName:"LayoutFilter"
    },
    {
      label: t('data.nodesConfig.annotations.layoutRowSection.label'),
      annotation: annotations.LayoutRowSection,
      annotationName:"LayoutRowSection"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartPrimaryDimCartesian.label'),
      annotation: annotations.LayoutChartPrimaryDimCartesian,
      annotationName:"LayoutChartPrimaryDimCartesian"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartSecondaryDimCartesian.label'),
      annotation: annotations.LayoutChartSecondaryDimCartesian,
      annotationName:"LayoutChartSecondaryDimCartesian"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartFilterCartesian.label'),
      annotation: annotations.LayoutChartFilterCartesian,
      annotationName:"LayoutChartFilterCartesian"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartLockedDimsCartesian.label'),
      annotation: annotations.LayoutChartLockedDimsCartesian,
      annotationName:"LayoutChartLockedDimsCartesian"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartPrimaryDimRadial.label'),
      annotation: annotations.LayoutChartPrimaryDimRadial,
      annotationName:"LayoutChartPrimaryDimRadial"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartSecondaryDimRadial.label'),
      annotation: annotations.LayoutChartSecondaryDimRadial,
      annotationName:"LayoutChartSecondaryDimRadial"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartFilterRadial.label'),
      annotation: annotations.LayoutChartFilterRadial,
      annotationName:"LayoutChartFilterRadial"
    },
    {
      label: t('data.nodesConfig.annotations.layoutChartLockedDimsRadial.label'),
      annotation: annotations.LayoutChartLockedDimsRadial,
      annotationName:"LayoutChartLockedDimsRadial"
    },
    {
      label: t('data.nodesConfig.annotations.layoutDataflowKeywords.label'),
      annotation: annotations.LayoutDataflowKeywords,
      annotationName:"LayoutDataflowKeywords"
    },
    {
      label: t('data.nodesConfig.annotations.layoutCriteriaSelection.label'),
      annotation: annotations.LayoutCriteriaSelection,
      annotationName:"LayoutCriteriaSelection"
    },
    {
      label: t('data.nodesConfig.annotations.layoutAttachedDataFiles.label'),
      annotation: annotations.LayoutAttachedDataFiles,
      annotationName:"LayoutAttachedDataFiles"
    },
    {
      label: t('data.nodesConfig.annotations.layoutDefaultPresentation.label'),
      annotation: annotations.LayoutDefaultPresentation,
      annotationName:"LayoutDefaultPresentation"
    },
    {
      label: t('data.nodesConfig.annotations.layoutDecimalSeparator.label'),
      annotation: annotations.LayoutDecimalSeparator,
      annotationName:"LayoutDecimalSeparator"
    },
    {
      label: t('data.nodesConfig.annotations.layoutNumberOfDecimals.label'),
      annotation: annotations.LayoutNumberOfDecimals,
      annotationName:"LayoutNumberOfDecimals"
    },
    {
      label: t('data.nodesConfig.annotations.layoutReferenceMetadata.label'),
      annotation: annotations.LayoutReferenceMetadata,
      annotationName:"LayoutReferenceMetadata"
    },
    {
      label: t('data.nodesConfig.annotations.layoutEmptyCellPlaceholder.label'),
      annotation: annotations.LayoutEmptyCellPlaceholder,
      annotationName:"LayoutEmptyCellPlaceholder"
    },
    {
      label: t('data.nodesConfig.annotations.layoutDataflowNotes.label'),
      annotation: annotations.LayoutDataflowNotes,
      annotationName:"LayoutDataflowNotes"
    },
    {
      label: t('data.nodesConfig.annotations.layoutTerritorialDimensionIds.label'),
      annotation: annotations.LayoutTerritorialDimensionIds,
      annotationName:"LayoutTerritorialDimensionIds"
    },
    {
      label: t('data.nodesConfig.annotations.layoutMapFilter.label'),
      annotation: annotations.LayoutMapFilter,
      annotationName: "LayoutMapFilter"
    },
    {
      label: t('data.nodesConfig.annotations.layoutDataflowSource.label'),
      annotation: annotations.LayoutDataflowSource,
      annotationName:"LayoutDataflowSource"
    },
    {
      label: t('data.nodesConfig.annotations.layoutHidden.label'),
      annotation: annotations.LayoutDataflowHidden,
      annotationName:"LayoutDataflowHidden"
    },
    {
      label: t('data.nodesConfig.annotations.notDisplayed.label'),
      annotation: annotations.NotDisplayed,
      annotationName:"NotDisplayed"
    },
    {
      label: t('data.nodesConfig.annotations.fullName.label'),
      annotation: annotations.FullName,
      annotationName:"FullName"
    }
  ];

  const defaultAnnotation =  {
      label: t('data.nodesConfig.annotations.default.label'),
      annotation: annotations.Default,
      annotationName:"Default"
  };

  const lastLayoutAnnotations = [
    { 
      label: t('data.nodesConfig.annotations.temporalDimOrder.label'),
      annotation: annotations.TemporalDimOrder,
      annotationName:"TemporalDimOrder"
    },
    { 
      label: t('data.nodesConfig.annotations.disabledViewers.label'),
      annotation: annotations.DisabledViewers,
      annotationName:"DisabledViewers"
    },
    { 
      label: t('data.nodesConfig.annotations.tableLockedDims.label'),
      annotation: annotations.TableLockedDims,
      annotationName:"TableLockedDims"
    },
    { 
      label: t('data.nodesConfig.annotations.hclReference.label'),
      annotation: annotations.HCLReference,
      annotationName:"HCLReference"
    },
    {
      label: t('data.nodesConfig.annotations.anticipationExceedingMaxNumRecords.label'),
      annotation: annotations.AnticipationExceedingMaxNumRecords,
      annotationName:"AnticipationExceedingMaxNumRecords"
    }
  ];

  const nonGroupedAnnotations = [    
    {
      label: t('data.nodesConfig.annotations.linkedDataflowNode.label'),
      annotation: annotations.LinkedDataflowNode,
      annotationName:"LinkedDataflowNode"
    },
      { 
        label: t('data.nodesConfig.annotations.dDBDataflow.label'),
        annotation: annotations.DDBDataflow,
        annotationName:"DDBDataflow"
      },
      { 
        label: t('data.nodesConfig.annotations.customDSD.label'),
        annotation: annotations.CustomDSD,
        annotationName:"CustomDSD"
      },
      { 
        label: t('data.nodesConfig.annotations.associatedCube.label'),
        annotation: annotations.AssociatedCube,
        annotationName:"AssociatedCube"
      },
      { 
        label: t('data.nodesConfig.annotations.changed.label'),
        annotation: annotations.Changed,
        annotationName:"Changed"
      },
      { 
        label: t('data.nodesConfig.annotations.metadataset.label'),
        annotation: annotations.Metadataset,
        annotationName:"Metadataset"
      },
      { 
        label: t('data.nodesConfig.annotations.haveMetadata.label'),
        annotation: annotations.HaveMetadata,
        annotationName:"HaveMetadata"
      },
      { 
        label: t('data.nodesConfig.annotations.dDBContentConstraint.label'),
        annotation: annotations.DDBContentConstraint,
        annotationName:"DDBContentConstraint"
      },
      { 
        label: t('data.nodesConfig.annotations.restrictedForPublication.label'),
        annotation: annotations.RestrictedForPublication,
        annotationName:"RestrictedForPublication"
      },
      { 
        label: t('data.nodesConfig.annotations.attachedFilePath.label'),
        annotation: annotations.AttachedFilePath,
        annotationName:"AttachedFilePath"
      },
      { 
        label: t('data.nodesConfig.annotations.dcatIsMultilingual.label'),
        annotation: annotations.DCAT_IsMultilingual,
        annotationName:"DCAT_IsMultilingual"
      },
      { 
        label: t('data.nodesConfig.annotations.customIsPresentational.label'),
        annotation: annotations.CustomIsPresentational,
        annotationName:"CustomIsPresentational"
      },
      { 
        label: t('data.nodesConfig.annotations.lastUpdate.label'),
        annotation: annotations.LastUpdate,
        annotationName:"LastUpdate"
      },
      { 
        label: t('data.nodesConfig.annotations.dataflowCatalogType.label'),
        annotation: annotations.DataflowCatalogType,
        annotationName:"DataflowCatalogType"
      },
      {
          label: t('data.nodesConfig.annotations.NonReadyForProduction.label'),
          annotation: annotations.NonReadyForProduction,
          annotationName:"NonReadyForProduction"
      },
      {
          label: t('data.nodesConfig.annotations.ReadyForProduction.label'),
          annotation: annotations.ReadyForProduction,
          annotationName:"ReadyForProduction"
      }
  ];

  const handleOnChange= (annotationName, annotation) => {
    annotations[annotationName] = annotation;    
    onChange(annotations);
  }


  return (    
  
  <Fragment>
      <AnnotationsCard 
        title={t("data.nodesConfig.annotations.cards.order.label")}
        annotations={orderAnnotations}
        onChange={handleOnChange}
      />
      <LayoutAnnotationsCard 
        title={t("data.nodesConfig.annotations.cards.layout.label")}
        firstAnnotations={firstLayoutAnnotations}
        defaultAnnotation={defaultAnnotation}
        lastAnnotations={lastLayoutAnnotations}
        onChange={handleOnChange}
      />
      {
        (nonGroupedAnnotations || []).map(({label, annotation, annotationName}, key) => 
          <AnnotationForm 
            key={key}
            label={label}
            value={annotation}
            name={annotationName}
            onChange={handleOnChange}
          />
        )
      }
      
    </Fragment>
  );
};

export default compose(
  translate(),
)(AnnotationsPanel);

